var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePresets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 47C39.8366 47 47 39.8366 47 31C47 22.1634 39.8366 15 31 15C22.1634 15 15 22.1634 15 31C15 39.8366 22.1634 47 31 47ZM22.4271 28.4864C22.2362 28.2501 21.89 28.2133 21.6537 28.4042C21.4174 28.5951 21.3806 28.9414 21.5715 29.1776C22.0616 29.7842 22.6767 30.442 23.4258 31.0658L21.5132 34.3784C21.3614 34.6415 21.4515 34.9779 21.7145 35.1298C21.9776 35.2816 22.314 35.1915 22.4659 34.9284L24.3084 31.7371C25.3111 32.4309 26.5054 33.0338 27.9059 33.4056L27.3288 36.6789C27.276 36.978 27.4758 37.2633 27.7749 37.3161C28.074 37.3688 28.3593 37.1691 28.412 36.8699L28.9821 33.6369C29.6168 33.7421 30.2888 33.8 30.9994 33.8C31.7073 33.8 32.377 33.7425 33.0096 33.6381L33.5797 36.8711C33.6324 37.1703 33.9177 37.37 34.2168 37.3173C34.5159 37.2645 34.7157 36.9793 34.6629 36.6801L34.0859 33.4075C35.4882 33.036 36.6839 32.433 37.6878 31.7389L39.5208 34.9137C39.6727 35.1767 40.0091 35.2668 40.2721 35.115C40.5352 34.9631 40.6253 34.6267 40.4734 34.3636L38.5706 31.0678C39.3207 30.4434 39.9366 29.7849 40.4272 29.1777C40.6181 28.9414 40.5813 28.5951 40.345 28.4042C40.1088 28.2133 39.7625 28.2501 39.5716 28.4864C38.056 30.3623 35.3085 32.7 30.9994 32.7C28.2053 32.7 26.0679 31.7172 24.4971 30.5147C24.4823 30.5021 24.4668 30.4902 24.4506 30.479C23.6202 29.8365 22.9503 29.1339 22.4271 28.4864Z",
    fill: "white",
    fillOpacity: 0.88,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePresets);
export default __webpack_public_path__ + "static/media/hide-presets.f27b28713347e7c759a0b1957800ca27.svg";
export { ForwardRef as ReactComponent };